import { isBBoxDegenerate } from './cropMath';
import type { BinBbox, DecodedSymbol } from '../types';

export interface SelectFreshArgs {
  symbols: DecodedSymbol[];
  hasDecoded: (text: string) => boolean;
}

/**
 * Pure: filter and order the decoder's symbols for dispatch. Steps:
 *   1. Drop degenerate bboxes (too small / NaN — see `isBBoxDegenerate`).
 *   2. Drop QRs already in this session's dedupe set.
 *   3. Sort by bbox area descending so the largest (closest, most
 *      confident) symbols win when a frame's dispatch budget is bound.
 *
 * Lives outside the React tree so the filter+sort can be vitest-tested
 * without rendering the whole page; the test-reviewer flagged the
 * inline version inside `handleFrame` as the single highest-ROI place
 * for a regression-catching unit test.
 */
export function selectFreshSymbolsForDispatch(args: SelectFreshArgs): DecodedSymbol[] {
  return args.symbols
    .filter((s) => !isBBoxDegenerate(s.bbox))
    .filter((s) => !args.hasDecoded(s.text))
    .slice()
    .sort((a, b) => bboxArea(b.bbox) - bboxArea(a.bbox));
}

export function bboxArea(b: BinBbox): number {
  return (b.x2 - b.x1) * (b.y2 - b.y1);
}
